import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { SubSectionHeader } from '../shared/SubSectionHeader';
import { FormField } from '../shared/FormField';
import classes from '../../bidAnalysisTemplate.module.scss';

interface TmopCalculatorSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  formData: any;
  validationErrors: Record<string, string>;
  onFieldChange: (field: string, value: any) => void;
  onFieldBlur: (field: string, value: any) => void;
  onFieldKeyDown?: (field: string, e: React.KeyboardEvent) => void;
}

export const TmopCalculatorSection: React.FC<TmopCalculatorSectionProps> = ({
  isExpanded,
  onToggle,
  formData,
  validationErrors,
  onFieldChange,
  onFieldBlur,
  onFieldKeyDown,
}) => {
  // Ensure formData is not undefined/null
  const safeFormData = formData || {};

  return (
    <div className={classes.subSection}>
      <SubSectionHeader title="TMOP Calculations" isExpanded={isExpanded} onToggle={onToggle} />
      {isExpanded && (
        <div className={classes.subSectionContent}>
          <div className={classes.formGrid3}>
            <FormField label="TMOP %" error={validationErrors?.tmopPercent}>
              <InputNumber
                value={safeFormData.tmopPercent ? parseFloat(safeFormData.tmopPercent) : null}
                onValueChange={e => onFieldChange('tmopPercent', e.value)}
                onBlur={e => onFieldBlur('tmopPercent', e)}
                onKeyDown={e => onFieldKeyDown?.('tmopPercent', e)}
                placeholder="Enter TMOP %"
                mode="decimal"
                minFractionDigits={0}
                maxFractionDigits={2}
                min={0}
                max={100}
                suffix="%"
                className={validationErrors?.tmopPercent ? 'p-invalid' : ''}
              />
            </FormField>

            <FormField label="Annual TMOP Savings">
              <InputNumber
                value={
                  safeFormData.annualTmopSavings ? parseFloat(safeFormData.annualTmopSavings) : 0
                }
                disabled
                prefix="$"
                mode="decimal"
                minFractionDigits={2}
                maxFractionDigits={2}
              />
            </FormField>

            <FormField label="Monthly TMOP Savings">
              <InputNumber
                value={
                  safeFormData.monthlyTmopSavings ? parseFloat(safeFormData.monthlyTmopSavings) : 0
                }
                disabled
                prefix="$"
                mode="decimal"
                minFractionDigits={2}
                maxFractionDigits={2}
              />
            </FormField>
          </div>
        </div>
      )}
    </div>
  );
};
